import { Outlet } from "react-router-dom";
import { Cursor } from "../atoms/Cursor";

export const BaseLayout = () => {
  return (
    <div>
      <Cursor />
      <main className="p-5">
        <Outlet />
      </main>
    </div>
  );
};
